module.exports = __webpack_public_path__ + "static/2025-06_tsar-gory-1e65ec1ade502d06ddbee657e0b775d5.jpg";